import { render, staticRenderFns } from "./verificationCode.vue?vue&type=template&id=34d8b2fc&scoped=true&"
import script from "./verificationCode.vue?vue&type=script&lang=js&"
export * from "./verificationCode.vue?vue&type=script&lang=js&"
import style0 from "./verificationCode.vue?vue&type=style&index=0&id=34d8b2fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d8b2fc",
  null
  
)

export default component.exports